import { render, staticRenderFns } from "./AddJobVacancy.vue?vue&type=template&id=4b1f8404&"
import script from "./AddJobVacancy.vue?vue&type=script&lang=js&"
export * from "./AddJobVacancy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports